module.exports = __webpack_public_path__ + "img/wximg8.3c1cbc56.png";